module.exports = __webpack_public_path__ + "img/code.78650dd6.jpg";